<main class="notifications">
  <h2 class="notifications-title">Standard Notifications:</h2>

  <div class="notifications-table">
    <div class="notifications-table__head">
      <h4>Notification Address:</h4>
      <h4>Notify On Send:</h4>
      <h4>Notify On Receive:</h4>
    </div>

    <ul *ngIf="!isLoading; else notificationsSkeleton" class="notifications-table__body">
      <li *ngFor="let notification of notifications; let i = index" class="notifications-table__row">
        <div class="notifications-table__cell">
          <button class="icon-btn icon-btn_md" (click)="deleteNotification(notification)">
            <img src="assets/icons/delete-orange.svg" alt="Delete notification" />
          </button>

          <p>Email</p>

          <input
            name="receiver"
            [(ngModel)]="notification.sendTo"
            [pattern]="notificationSendToPattern"
            class="form-input_md"
          />

          <div class="notifications-table__row-actions">
            <button class="icon-btn icon-btn_md" (click)="openSearchContactModal(i)">
              <img src="assets/img/keylock-plus.svg" alt="Add receiver from contacts" />
            </button>

            <button class="icon-btn icon-btn_md" (click)="resetNotificationSendTo(i)">
              <img src="assets/img/stop.svg" alt="Reset receiver field" />
            </button>
          </div>
        </div>

        <div class="notifications-table__cell">
          <app-select
            [items]="notificationStatuses"
            [activeItem]="notification.onSendStatus"
            class="notification__select"
            [customClass]="'select_max'"
            (selectChange)="changeNotificationOnSendStatus(i, $event)"
          ></app-select>

          <app-select
            [items]="notificationAttachmentTypes"
            [activeItem]="getNotificationAttachmentOnSendType(notification)"
            class="notification__select"
            [customClass]="'select_max'"
            (selectChange)="changeNotificationHasAttachmentOnSend(i, $event)"
          ></app-select>
        </div>

        <div class="notifications-table__cell">
          <app-select
            [items]="notificationStatuses"
            [activeItem]="notification.onReceiveStatus"
            class="notification__select"
            [customClass]="'select_max'"
            (selectChange)="changeNotificationOnReceiveStatus(i, $event)"
          ></app-select>

          <app-select
            [items]="notificationAttachmentTypes"
            [activeItem]="getNotificationAttachmentOnReceiveType(notification)"
            class="notification__select"
            [customClass]="'select_max'"
            (selectChange)="changeNotificationHasAttachmentOnReceive(i, $event)"
          ></app-select>
        </div>
      </li>
    </ul>

    <ng-template #notificationsSkeleton>
      <ul class="notifications-table__body">
        <li *ngFor="let row of skeletonRows" class="notifications-table__row">
          <div class="notifications-table__cell">
            <span class="skeleton notifications-table__cell-skeleton"></span>
          </div>

          <div class="notifications-table__cell">
            <span class="skeleton notifications-table__cell-skeleton"></span>
          </div>

          <div class="notifications-table__cell">
            <span class="skeleton notifications-table__cell-skeleton"></span>
          </div>
        </li>
      </ul>
    </ng-template>

    <button
      *ngIf="!isLoading && notifications.length < notificationsLimit"
      class="btn_primary btn_sm notifications__add-button"
      (click)="createNotification()"
    >
      <img src="assets/img/icons/plus.webp" alt="Create notification" />
    </button>
  </div>

  <div class="actions">
    <button class="btn_plain btn_sm" (click)="resetNotifications()">Reset</button>

    <button
      [disabled]="isSomeNotificationSendToInvalid"
      class="btn_primary btn_sm"
      (click)="saveNotifications()"
    >
      Save
    </button>
  </div>
</main>

<app-search-contact-modal (select)="selectContact($event)"></app-search-contact-modal>
